export default "__VITE_ASSET__fDAZSNLm__"